import{ useEffect, useState } from 'react'
import { Button,  Header, Icon,Form, Input, Label, Select,  TextArea,Pagination, Table, TableHeader, TableHeaderCell, TableRow, TableFooter, TableBody, TableCell} from 'semantic-ui-react'
import { dropTitleCode } from '../../../app/models/Restoration';
import { useStore } from "../../../app/stores/store";
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import "./ClientCorrectionstyles.css";
import { v4 as uuidv4 } from 'uuid';
const ClientCorrection = () => {
const { RestorationStore,userStore} = useStore();
const [friendOptions, setFriendOptions] = useState<dropTitleCode[]>([]);
const [selectedTitleCode, setSelectedTitleCode] = useState<string>('');
const [selectModifyId,setSelectModifyId]=useState<string>('');
const [client_FeedBack,setClientFeedBack]=useState<string>('');
const [prasadComments,setPrasadComments]=useState<string>('');
const [selectCategory,setSelectCategory]=useState<string>('');
const [frameCount, setFrameCount]=useState<string>('');
const [status, setStatus]=useState<string>('');
const [teamName, setTeamName]=useState<string>('');
const [dataType,setDataType]=useState<string>('');
const currentDate = new Date();
const [scheduleDate,setScheduleDate]=useState<Date>(currentDate);
const [requestedDate,setRequestedDate]=useState<Date>(currentDate);
const [uploadStatus,setUploadStatus]=useState<Date>(currentDate);
const [titleInformation,setTitleInformation]=useState<RestorationClientServiceTitleInformation | null>(null);
const [clientCorrectionInformation,setClientCorrectionInformation]=useState<ClientCorrectionDetails[]>([]);
const [currentPage, setCurrentPage] = useState<number>(1);
const [totalPages,setTotalPages]=useState<number>(1);
const [totalItems, setTotalItems] = useState<number>(0);
const itemsPerPage = 10;
const [file, setFile] = useState<File|null>(null);
const [prasadCommentsfile, setPrasadCommentsFile] = useState<File|null>(null);
const Titlecode = async()=>{
    await RestorationStore.getLiveTitleCode();
    const projectCode = RestorationStore.dropTitleCode;
    setFriendOptions(projectCode);
  }
  const loadData=async()=>{
    try {
      paginationCount();
      const response = await axios.get(`/ClientCorrection/clientCorrectionList?PageNumber=${currentPage}&PageSize=${itemsPerPage}`);
      setClientCorrectionInformation(response.data)
      setTitleInformation(response.data);
    } catch (error) {
      toast.error("Error fetching title information:");
    }
  }
  const fetchTitleInformation = async (titleCode: string) => {
    try {
      const response = await axios.get(`/ClientCorrection/Titleinfo?titleCode=${titleCode}`);
      setTitleInformation(response.data);
    } catch (error) {
      toast.error("Error fetching title information:");
    }
  };

  const handleDropdownChange = async (_e: any, data: any) => {
    setSelectedTitleCode(data.value);
    await fetchTitleInformation(data.value);
  };
  const handleDropdownCategory=async (_e:any,data:any)=>{
    setSelectCategory(data.value)
  }
  const handleDropdownStatus=async (_e:any,data:any)=>{
    setStatus(data.value)
  }
  const handleDropdownTeamName=async (_e:any,data:any)=>{
    setTeamName(data.value)
  }
  const activeAddNew=()=>{
    setDataType('newRecord');
    setTitleInformation(null);
    setSelectedTitleCode('');

  }

  const updateDataType = (rowData: ClientCorrectionDetails) => {
      const getValidDate = (dateStr: string | null | undefined): Date => {
          if (!dateStr) return new Date();

          const parts = dateStr.split('-');
          if (parts.length !== 3) return new Date();

          const [day, month, year] = parts.map(part => parseInt(part, 10));
          if (isNaN(day) || isNaN(month) || isNaN(year)) return new Date();

          return new Date(Date.UTC(year, month - 1, day));
      };

      const newSchedule = getValidDate(rowData.scheduledate);
      const newRequest = getValidDate(rowData.date);
      const newUpload = getValidDate(rowData.uploadStatus);

      setDataType('UpdatedRecord');
      setFrameCount(rowData.noofframes);
      setSelectCategory(rowData.category);
      setClientFeedBack(rowData.clientfeedback);
      setStatus(rowData.status);
      setScheduleDate(newSchedule);
      setRequestedDate(newRequest);
      setPrasadComments(rowData.prasadComment);
      setUploadStatus(newUpload);
      setSelectModifyId(rowData.id);
      setTeamName(rowData.teamName);

      const titleData: RestorationClientServiceTitleInformation = {
          title_Code: rowData.title_Code,
          title_Name: rowData.title_Name,
          resolution: rowData.resolution
      };
      
      setSelectedTitleCode(rowData.title_Code);
      setTitleInformation(titleData); 
  };

   useEffect(()=>{
    Titlecode();
    paginationCount();
    // eslint-disable-next-line
   },[])
   
   useEffect(()=>{
    loadData();
    //eslint-disable-next-line
   },[currentPage])
   const handlePaginationChange=(e: any, { activePage }: any)=>
        {
          setCurrentPage(activePage);
        }

   const statusUpdate= async()=>{
    const formData = new FormData();
    formData.append('id', selectModifyId ? selectModifyId : uuidv4());
    formData.append('title_Code', titleInformation?.title_Code || '');
    formData.append('title_Name', titleInformation?.title_Name || '');
    formData.append('catagory', selectCategory || '');
    formData.append('resolution', titleInformation?.resolution || '');
    formData.append('No_of_frames', frameCount.toString());
    formData.append('client_FeedBack', client_FeedBack || '');
    formData.append('status', status || '');
    formData.append('schedule_date', scheduleDate ? scheduleDate.toISOString() : "");
    formData.append('requested_date', requestedDate ? requestedDate.toISOString() : "");
    formData.append('prasad_comments', prasadComments || '');
    formData.append('upload_Status', uploadStatus ? uploadStatus.toISOString() : "");
    if (file) formData.append('File', file); // Only append if the file exists
    if (prasadCommentsfile) formData.append('PrasadCommentsFile', prasadCommentsfile); // Similarly for prasadCommentsfile
    formData.append('teamName', teamName || '');
    if (dataType === 'newRecord') {
        try {
            const response = await axios.post(`/ClientCorrection/addCreateCorrection`, formData);
            loadData(); 
            toast.success(response.data);
        } catch (error) {
            toast.error('Error submitting data');
        }
    }
    if(dataType==='UpdatedRecord')
       { 
        try { const response=await axios.put(`/ClientCorrection/ClientCorrectEdit`,formData);
                      loadData();
                      toast.success(response.data);
             }
        catch(error)
          {
            toast.error("Please enter Valid Data")
            return;
          }   
        }
    resetForm();
    }
const resetForm = () => {
    setDataType('');
    setFrameCount('');
    setSelectCategory('');
    setClientFeedBack('');
    setStatus('');
    setTeamName('');
    setScheduleDate(currentDate);
    setRequestedDate(currentDate);
    setPrasadComments('');
    setUploadStatus(currentDate);
    setTitleInformation(null);
};
    const paginationCount = async () => {
      try {
        const response = await axios.get(`/ClientCorrection/ClientCorrectionCount`);
        const totalItemsCount = response.data; 
        const totalPagesCount = Math.ceil(totalItemsCount / itemsPerPage); 
        setTotalPages(totalPagesCount);
        setTotalItems(totalItemsCount);
      } 
      catch (error) 
      {
        toast.error("Please create Client Correction Data")
      }
    };

    const extensionMap: { [key: string]: string } = {
  'application/pdf': 'pdf',
  'text/csv': 'csv',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/zip': 'zip',
  // add more as needed
};

const PrasadCommentsdownload = async (id: string, titlecode: string) => {
  try {
    const response = await axios.get(`/ClientCorrection/PrasadCommentdownloadFile?id=${id}`, {
      responseType: 'blob',
    });
    const contentType = response.headers['content-type'];
    const ext = extensionMap[contentType] || 'bin';
    let fileName = `${titlecode}_PrasadComments.${ext}`;
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.includes('filename=')) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        fileName = decodeURIComponent(match[1].replace(/['"]/g, '').trim());
      }
    }
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error("Record Not Found");
  }
};

const download = async (id: string, titlecode: string) => {
  try {
    const response = await axios.get(`/ClientCorrection/downloadFile?id=${id}`, {
      responseType: 'blob',
    });
    const contentType = response.headers['content-type'];
    const ext = extensionMap[contentType] || 'bin';
    let fileName = `${titlecode}_ClientCorrection.${ext}`;
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.includes('filename=')) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        fileName = decodeURIComponent(match[1].replace(/['"]/g, '').trim());
      }
    }
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error("Record Not Found");
  }
};  

   

 const setDate=(date: Date,type: string)=>{
    try {
      if (type === 'requestedDate') {
          setRequestedDate(date);
      } 
      if(type==='scheduleDate'){
        setScheduleDate(date);
      }
      if(type==='uploadStatus'){
        setUploadStatus(date);
      } 
  } catch (error) {
      toast.error('Error fetching Date');
  }}

  const handleDownloadCSVReport = async () => {
    try {
      const response = await axios.get(`/ClientCorrection/clientCorrectionList?PageNumber=1&PageSize=${totalItems}`);
      const allRecords: ClientCorrectionDetails[] = response.data;
      const headers = [
        'S.No','Date','Title Code','Category','Title Name','Resolution','Team Name',
        'No of frames','Client feedback','Status','Schedule Date','Prasad Comment','Upload Status'
      ];
      const rows = [headers];

      const formatCell = (cell: any) => {
        if (cell === null || cell === undefined) return '';
        const cellStr = String(cell).replace(/"/g, '""');
        return `"${cellStr}"`;
      };

      allRecords.forEach((record) => {
        const row = [
          record.s_No,
          record.date,
          record.title_Code,
          record.category,
          record.title_Name,
          record.resolution,
          record.teamName,
          record.noofframes,
          record.clientfeedback,
          record.status,
          record.scheduledate,
          record.prasadComment,
          record.uploadStatus
        ].map(formatCell);
        rows.push(row);
      });

      const csvString = rows.map(r => r.join(",")).join("\r\n");

      const blob = new Blob([`\uFEFF${csvString}`], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const date = new Date();
      const formattedDate = date.toISOString().slice(0, 10);
      link.setAttribute("href", url);
      link.setAttribute("download", `Client_Correction_Report_${formattedDate}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to download full CSV data.");
      console.error("CSV download error:", error);
    }
  };

   const CategoryOptions=[
    { key: 1, text: 'INT', value: 'INT' },
      { key: 2, text: 'DOM', value: 'DOM' }
    ]
    const statusOptions=[
      { key: 1, text: 'YTS', value: 'YTS' },
      { key: 2, text: 'WIP', value: 'WIP' },
      { key: 3, text: 'Completed', value: 'Completed' }
      ]
      const teamOptions=[
        { key: 1, text: 'Cluster 1', value: 'Cluster 1' },
        { key: 2, text: 'Cluster 2', value: 'Cluster 2' },
        { key: 3, text: 'Cluster 3', value: 'Cluster 3' },
        { key: 4, text: 'Cluster 4', value: 'Cluster 4' },
        { key: 5, text: 'Cluster 5', value: 'Cluster 5' },
        { key: 6, text: 'Cluster 6', value: 'Cluster 6' },
        { key: 6, text: 'Cluster 7', value: 'Cluster 7' },
        { key: 6, text: 'Cluster 8', value: 'Cluster 8' },
        { key: 6, text: 'Cluster 9', value: 'Cluster 9' },
        { key: 6, text: 'Cluster 10', value: 'Cluster 10' },
        { key: 6, text: 'R&D Team', value: 'R&D Team' }
        ]
        const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];
        if (selectedFile) { setFile(selectedFile); } else {setFile(null); }};
    const handlePrasadCommentFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {setPrasadCommentsFile(file); }};

  return (
    <>
        <div style={{width:"80%",marginLeft:"10%"}}>
            <Header>Restoration Client Correction</Header>
            <div className="ui form">
           
            <Form>
            <Form.Group widths="7" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Form.Field style={{ textAlign: "right" }}>
                <Button
                  as="div"
                  labelPosition="right"
                  onClick={activeAddNew}
                  inverted
                  color="green"
                >
                  <Button icon onClick={activeAddNew} inverted color="green">
                    <Icon name="plus" />
                  </Button>
                  <Label as="a" basic pointing="left" inverted color="green">
                    Add
                  </Label>
                </Button>

                <Button
                  as="div"
                  labelPosition="right"
                  inverted
                  color="blue"
                  style={{ marginLeft: "10px" }}
                >
                  <Button icon onClick={handleDownloadCSVReport} inverted color="blue">
                    <Icon name="download" />
                  </Button>
                  <Label as="a" basic pointing="left" inverted color="blue">
                    Download
                  </Label>
                </Button>
              </Form.Field>
            </Form.Group>
            { dataType!=='' && <>
            <Form.Group widths="7">
                <Form.Field>
                    <div className='flex-row'>
                    <label className='label-margin'>Title Code</label><Select
                        placeholder="Select Title Code"
                        selection
                        search
                        clearable
                        options={friendOptions}
                        value={selectedTitleCode}
                        onChange={(_event, data) => handleDropdownChange(_event, data)}/>
                    </div>
                </Form.Field>
                <Form.Field>
                   <div className='flex-row'>
                   <label className='label-margin'>Title Name</label>
                   <Input value={titleInformation?.title_Name || 'N/A'} readOnly/>
                   </div>
                </Form.Field>
                <Form.Field>
                    <div className='flex-row'>
                    <label className='label-margin'>Resolution</label>
                    <Input value={titleInformation?.resolution || 'N/A'} readOnly />
                    </div>
                </Form.Field>
                <Form.Field>
                    <div className='flex-row'>
                    <label className='label-margin'>Team Name</label>
                    <Select
                    placeholder="status"
                    selection
                    search
                    clearable
                    multiple
                    options={teamOptions}
                    value={teamName}
                    onChange={(_event, data) => handleDropdownTeamName(_event, data)}
                    />
                    </div>
                </Form.Field>
                <Form.Field>
                    <div className='flex-row'>
                        <label className='label-margin'>Requested Date</label>
                        <DatePicker selected={requestedDate} onChange={(date:Date)=>setDate(date,'requestedDate')} className="date-picker-style"/>
                    </div>
                </Form.Field>
                <Form.Field>
                    <div className='flex-row'>
                        <label className='label-margin'>Catagory</label>
                        <Select placeholder="Catagory" selection search clearable options={CategoryOptions} value={selectCategory} onChange={(_event, data) => handleDropdownCategory(_event, data)}/>
                    </div>
                </Form.Field>
                <Form.Field>
                    <div className='flex-row'>
                        <label className='label-margin'>Schedule date</label>
                        <DatePicker className="date-picker-style" selected={scheduleDate} onChange={(date:Date)=>setDate(date,'scheduleDate')} wrapperClassName="date-picker-wrapper" />
                    </div>
                </Form.Field>
            </Form.Group>
            <Form.Group widths="7">
                <Form.Field>
                    <div className='flex-row'>
                    <br/>
                    <br/>
                        <label className='label-margin'>No of frames</label>
                        <Input value={frameCount} onChange={(e) => setFrameCount(e.target.value)} number/>
                    </div>
                    
                </Form.Field>
                <Form.Field style={{ width: '25%' }}>
                
                    <div className='flex-row'>
                        <label className='label-margin'>Client feedback</label>
                        <TextArea style={{border: '1px solid lightgray'}} onChange={(e)=>setClientFeedBack(e.target.value)} value={client_FeedBack}/>
                    </div>
            </Form.Field>
            { dataType!=='UpdatedRecord' && (
            <Form.Field style={{alignitems:'center',width: '15%' }}>
                <div className='flex-row'>
                <br/>
                <br/>
                    <label className='label-margin'>Upload Client FeedBack</label>
                    <Input type="file" onChange={handleFileChange}/>
                </div>
            </Form.Field>)}
            <Form.Field style={{ width: '25%' }}>
                    <div className='flex-row'>
                        <label className='label-margin'>Prasad Comment</label>
                        <TextArea style={{borderradius: '29px',border: '1px solid lightgray'}} onChange={(e)=>setPrasadComments(e.target.value)} value={prasadComments}/>
                    </div>
            </Form.Field>
            <Form.Field style={{alignitems:'center',width: '15%' }}>
                <div className='flex-row'>
                    <br/>
                    <br/>
                    <label className='label-margin'>Prasad Comments File</label>
                    <Input type="file" onChange={handlePrasadCommentFileChange}  />
                </div>
            </Form.Field>
            </Form.Group>
            <Form.Group widths="7">
            <Form.Field>
                <div className='flex-row'>
                    <label className='label-margin'>Status</label>
                    <Select placeholder="status" selection search clearable options={statusOptions} value={status} onChange={(_event, data) => handleDropdownStatus(_event, data)}/>
                </div>
            </Form.Field>
            <Form.Field>
            {userStore.user?.departmentName==="Data Management" && (
                <div className='flex-row'>
                    <label className='label-margin'>Upload Status</label>
                    <DatePicker className="date-picker-style" selected={uploadStatus} onChange={(date:Date)=>setDate(date,'uploadStatus')} wrapperClassName="date-picker-wrapper" />
                </div>)}
            </Form.Field>
            <Form.Field>
             <br/>
            <Button onClick={statusUpdate} className='ui positive basic button'><Icon className='thumbs up outline'/>Submit</Button>
            </Form.Field>
            </Form.Group>
            </>}
            </Form>
            
</div>
{/* <Table>
<TableHeader>
  <TableHeaderCell>S.No</TableHeaderCell>
  <TableHeaderCell>Date</TableHeaderCell>
    <TableHeaderCell>Title Code</TableHeaderCell>
    <TableHeaderCell>Catagory</TableHeaderCell>
    <TableHeaderCell>Title Name</TableHeaderCell>
    <TableHeaderCell>Resolution</TableHeaderCell>
    <TableHeaderCell>Team Name</TableHeaderCell>
    <TableHeaderCell>No of frames</TableHeaderCell>
    <TableHeaderCell>Client feedback</TableHeaderCell>
    <TableHeaderCell>Client Feedback File</TableHeaderCell>
    <TableHeaderCell>Status</TableHeaderCell>
    <TableHeaderCell>Schedule Date</TableHeaderCell>
    <TableHeaderCell>Prasad Comment</TableHeaderCell>
    <TableHeaderCell>Prasad Comments File</TableHeaderCell>
    <TableHeaderCell>Upload Status</TableHeaderCell>
    <TableHeaderCell>Modify Record</TableHeaderCell>
</TableHeader>
<tbody>

    {clientCorrectionInformation.map((item,index)=>(
    <tr key={index} style={{fontStyle:"initial"}}>
      <td>{item.s_No}</td>
      <td>{item.date}</td>
      <td>{item.title_Code}</td>
      <td>{item.category}</td>
      <td>{item.title_Name}</td>
      <td>{item.resolution}</td>
      <td>{item.teamName}</td>
      <td>{item.noofframes}</td>
      <td style={{wordWrap:'break-word',whiteSpace: 'normal' }}>{item.clientfeedback}</td>
      <td><Icon className='download' onClick={(e:any)=>download(item.id,item.title_Code)} style={{color:'blue'}}/></td>
      <td>{item.status}</td>
      <td>{item.scheduledate}</td>
      <td>{item.prasadComment}</td>
      <td><Icon className='download' onClick={(e:any)=>PrasadCommentsdownload(item.id,item.title_Code)} style={{color:'blue'}}/></td>
      <td>{item.uploadStatus}</td>
      <td><Icon className='edit outline' onClick={(e:any)=>updateDataType(item)} style={{color:'orange'}}/></td>
    </tr> 
    ))}
     {totalPages > 0 && (
    <tr style={{ border: "none" }}>
        <td colSpan={32} style={{ border: "none" }}>
      <Pagination
        activePage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePaginationChange}
       />
      </td>
    </tr>)}
    </tbody>
</Table> */}
<Table celled>
    <TableHeader>
        
      <TableRow>
        <TableHeaderCell>S.No</TableHeaderCell>
        <TableHeaderCell>Date</TableHeaderCell>
        <TableHeaderCell>Title Code</TableHeaderCell>
        <TableHeaderCell>Catagory</TableHeaderCell>
        <TableHeaderCell>Title Name</TableHeaderCell>
        <TableHeaderCell>Resolution</TableHeaderCell>
        <TableHeaderCell>Team Name</TableHeaderCell>
        <TableHeaderCell>No of frames</TableHeaderCell>
        <TableHeaderCell>Client feedback</TableHeaderCell>
        <TableHeaderCell>Client Feedback File</TableHeaderCell>
        <TableHeaderCell>Status</TableHeaderCell>
        <TableHeaderCell>Schedule Date</TableHeaderCell>
        <TableHeaderCell>Prasad Comment</TableHeaderCell>
        <TableHeaderCell>Prasad Comments File</TableHeaderCell>
        <TableHeaderCell>Upload Status</TableHeaderCell>
        <TableHeaderCell>Modify Record</TableHeaderCell>
      </TableRow>
    </TableHeader>

    <TableBody>
    {clientCorrectionInformation.map((item,index)=>(
      <TableRow key={index} >
        <TableCell>{item.s_No}</TableCell>
        <TableCell>{item.date}</TableCell>
        <TableCell>{item.title_Code}</TableCell>
        <TableCell>{item.category}</TableCell>
        <TableCell>{item.title_Name}</TableCell>
        <TableCell>{item.resolution}</TableCell>
        <TableCell>{item.teamName}</TableCell>
        <TableCell>{item.noofframes}</TableCell>
        <TableCell>{item.clientfeedback}</TableCell>
        <TableCell><Icon className='download' onClick={(e:any)=>download(item.id,item.title_Code)} style={{color:'blue'}}/></TableCell>
        <TableCell>{item.status}</TableCell>
        <TableCell>{item.scheduledate}</TableCell>
        <TableCell>{item.prasadComment}</TableCell>
        <TableCell><Icon className='download' onClick={(e:any)=>PrasadCommentsdownload(item.id,item.title_Code)} style={{color:'blue'}}/></TableCell>
        <TableCell>{item.uploadStatus}</TableCell>
        <TableCell><Icon className='edit outline' onClick={(e:any)=>updateDataType(item)} style={{color:'orange'}}/></TableCell>
      </TableRow>))}
    </TableBody>

    <TableFooter>
      <TableRow>
        <TableHeaderCell colSpan='16'>
        <Pagination
        activePage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePaginationChange}
       />
        </TableHeaderCell>
      </TableRow>
    </TableFooter>
  </Table>
</div>
    </>
    
  )
}

export default ClientCorrection

interface RestorationClientServiceTitleInformation
{
    title_Code:string;
    title_Name:string;
    resolution:string;
}

interface ClientCorrectionDetails {
    s_No: number;
    id: string;
    date: string;
    title_Code: string;
    category: string;
    title_Name: string;
    resolution: string;
    noofframes: string;
    clientfeedback: string;
    status: string;
    scheduledate: string;
    prasadComment: string;
    uploadStatus: string;
    teamName: string;
  }


